export function waitlistFirstSeenStorageKey(feature: string): string {
  return `waitlist-first-seen-${feature}`;
}

export function parseWaitlistFirstSeenMs(value: string | null): number | null {
  if (value == null || value.trim() === "") {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null;
  }

  return parsed;
}

export function startOfLocalDayMs(nowMs: number): number {
  const date = new Date(nowMs);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}

export function shouldOfferWaitlistOnReturn(input: {
  firstSeenAtMs: number | null;
  nowMs: number;
}): boolean {
  if (input.firstSeenAtMs == null) {
    return false;
  }

  return startOfLocalDayMs(input.nowMs) > startOfLocalDayMs(input.firstSeenAtMs);
}

export function resolveWaitlistReturnOffer(input: {
  storedFirstSeen: string | null;
  nowMs: number;
}): { offer: boolean; firstSeenAtMs: number } {
  const firstSeenAtMs = parseWaitlistFirstSeenMs(input.storedFirstSeen);
  if (firstSeenAtMs == null) {
    return { offer: false, firstSeenAtMs: input.nowMs };
  }

  return {
    offer: shouldOfferWaitlistOnReturn({
      firstSeenAtMs,
      nowMs: input.nowMs,
    }),
    firstSeenAtMs,
  };
}
